import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToasterService } from './toaster.service';
import { Router } from '@angular/router';
import { Observable, catchError, forkJoin, map, of, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private deviceStartId: number = 3000;
  private model: string = 'wifidetector';

  constructor(private http: HttpClient, public router: Router, private toaster: ToasterService) { }


  getDevicesSerial(): Observable<any> {
    const observables: Observable<any>[] = [];
    const url = `${environment.host}/device?filter=id&from=${this.deviceStartId}&page=1`;
    return this.http.get(url).pipe(
      map((res) => {
        return res || {};
      })
    );
  }


  getDeviceDetails(deviceID: string): Observable<any> {
    const api = `${environment.host}/${environment.device}/${deviceID}`;
    return this.http.get(api).pipe(
      map((res) => {
        return res || {};
      })
    );
  }

  getDeviceLocation(deviceID: string): Observable<any> {
    const api = `${environment.host}/${environment.user}/${deviceID}/${environment.location}`;
    return this.http.get(api).pipe(
      map((res) => {
        return res || {};
      })
    );
  }

  getConnectedDevices(deviceID: string): Observable<any> {
    const api = `${environment.host}/${environment.user}/${deviceID}/${environment.device}`;
    return this.http.get(api).pipe(
      map((res) => {
        return res || {};
      })
    );
  }

  getDeviceData(deviceID: string): Observable<any> {
    const apiUrl = `${environment.host}/device/${deviceID}`;
    return this.http.get(apiUrl);
  }

  getDeviceDatBySerial(serialNumber: string, currentPage: number): Observable<any> {
    const apiURL = `${environment.host}/device?filter=serial&from=${serialNumber}&page=${currentPage}`;
    return this.http.get(apiURL);
  }

  getDeviceDataWithLocation(deviceID: string, locationID: string): Observable<any> {
    const apiUrl = `${environment.host}/location/${locationID}/device/${deviceID}`;
    return this.http.get(apiUrl);
  }

  getDeviceStats(
    locId: number,
    devId: number,
    measureNames: string[],
    ago_duration: string,
    interval: string
  ): Observable<any> {
    const url = `${environment.host}/location/${locId}/device/${devId}/stats`;
    const requestBody = {
      measure_names: measureNames,
      ago_duration: ago_duration,
      interval: interval,
      aggregate_function: "avg",
    };
    return this.http.post(url, requestBody);
  }

  getDeviceIAQStats(devices: number[], measureNames: string, ago_duration: string | null, start_time: string | null, end_time: string | null): Observable<any> {
    const url = `${environment.host}/iaq/chart`;
    const requestBody = {
      devices,
      measure_name: measureNames,
      start_time,
      end_time,
      ...(ago_duration && { ago: ago_duration }), // adds 'ago: ago_duration' if only æago_duration' is true
    };
    
    return this.http.post(url, requestBody);
  }
}